
// import {SuperDebug, ServerDebug} from '../../../utils/debug/Sdebug';
// let debug_mt = ServerDebug('middle-trim', false);

export class String_Validate_Password {

    public static getWord() {
        return '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    }

    public static getSymbols() {

        // 键盘上的所有符号，包含空格，有 33 个字符
        let chars = ([
            "`~!@#$%^&*()_+ -=[]{};':",         // 含空格，不含双引号
            '"',                                // 双引号
            ",./<>?\\|"]).join('');             // 含反斜线

        return chars;

    }

    public static getWhiteList() {

        let list = '0-9a-zA-Z';
        this.getSymbols().split('').forEach(char => {
            list += '\\' + char;
        });

        return list;

    }

    public static testByWidth(password, min = 6, max = 18) {

        let ret = false;

        let white_list = this.getWhiteList();
        let conf = `^[${white_list}]{${min},${max}}` + '$';

        let regex = new RegExp(conf, 'i');

        // console.log(regex);

        ret = regex.test(password);

        return ret;

    }

}
